import { render, staticRenderFns } from "./StudentCurriculum.vue?vue&type=template&id=065a0a98&scoped=true&lang=pug&"
import script from "./StudentCurriculum.vue?vue&type=script&lang=ts&"
export * from "./StudentCurriculum.vue?vue&type=script&lang=ts&"
import style0 from "./StudentCurriculum.vue?vue&type=style&index=0&id=065a0a98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a0a98",
  null
  
)

export default component.exports